<div class="status__content">
	<span *ngIf="isGSE" class="gse-validation" cvTooltip [tooltipText]="'GSE Revision'">{{
		cellValue.status
	}}</span>
	<span *ngIf="!isGSE">
		{{ cellValue.status }}
	</span>
</div>
